import { parseSiteHash } from './docs-routing';
function stateFromLocation() {
    if (typeof window === 'undefined') {
        return { view: 'landing', docsComponent: null };
    }
    return parseSiteHash(window.location.hash);
}
export const initialState = {
    ...stateFromLocation(),
    docsSidebarOpen: false,
    engineVersion: '0.20.0',
};
